import { api } from './api'

export const getActivitiesAPI = () => {
  return api.get(`/activitiesV2`).then(res => {
    return res
  })
}
